import Vue from '../../../lib/utils/vue'
import VueI18n from 'vue-i18n'
import { styled } from '@egoist/vue-emotion'
import * as getters from '../../../../builder/src/js/store/modules/getters'
import * as actions from '../../../../builder/src/js/store/modules/actions'
import * as constants from '../../../../builder/src/js/common/constants/constants'
import { mapGetters, mapState, mapActions } from 'vuex'
import CvtButton from '../../molecules/Button'
import CvtInput from '../../molecules/Input'
import CvtSelect from '../../molecules/Select'
import CvtCustomCheckbox from '../../molecules/CustomCheckbox'
import CvtRadioGroup from '../../molecules/radio-group/RadioGroup'
import CvtRadio from '../../molecules/radio-group/Radio'
import { IntegrationReady } from './integration-ready'
import { IntegrationDescription } from './integration-description'
Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

const getRadioGroup = () => styled(CvtRadioGroup)``

const getRadio = () => styled(CvtRadio)`
  font-size: 14px;
  font-weight: 400;
  label > span:after {
    top: 2px !important;
    left: 2px !important;
  }
`

const getInput = () => styled(CvtInput)`
  > div {
    border-radius: 0;
  }
  > div > div {
    border-radius: 0;
    border: 0;
  }
`

const getCheckboxInputLabel = () => styled('p')`
  margin-bottom: 20px;
  font-size: 14px;
`

const getSheetSelectDropdown = () => styled(CvtSelect)`
  width: 100%;

  > div {
    border-radius: 0;
  }

  div > div {
    border-radius: 0;
    border: 0;
  }
`

const getSheetSelectButtonWrap = () => styled('div')`
  margin-left: 10px;
  button {
    padding: 13px;
  }
`

const getAuthenticationDescription = () => styled('div')`
  background: ${Colors.BASIC[100]};
`

const getHorizontalLine = () => styled('div')`
  border-top: 1px solid ${Colors.BASIC[300]};
  margin-bottom: 15px;
`

const getSheetSelectWrap = () => styled('div')`
  display: flex;
  align-items: end;
  justify-content: space-between;
`

const getSheetNameContainer = () => styled('div')`
  margin-top: 20px;
  margin-bottom: 24px;
`

const getSheetName = () => styled('p')`
  margin-bottom: 8px;
`

const getAuthSuccessBtnWrap = () => styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`

const getAuthDescriptionHeader = () => styled('p')`
  font-weight: 700;
  font-size: 14px;
  color: ${Colors.BASIC[500]};
`

const getSelectFieldsContainer = () => styled('div')`
  margin: 23px 0;
`

const getCustomCheckbox = () => styled(CvtCustomCheckbox)``

export const GoogleSheetIntegration = {
  name: 'GoogleSheetIntegration',
  components: {
    CvtRadioGroup,
  },
  data() {
    return {
      initialRadioValue: '',
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      selectedIntegration: getters.SELECTED_INTEGRATION,
      currentStep: getters.GET_INTEGRATIONS_AUTH_STEP,
      formFieldGroups: getters.FORM_EDITOR_FIELD_GROUPS,
    }),
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
    }),

    getExistingSpreadSheets() {
      return ['Spreadsheet 1', 'Spreadsheet 2', 'Spreadsheet 3']
    },

    isUnselected() {
      return this.initialRadioValue === ''
    },
    isCreateNew() {
      return this.initialRadioValue === constants.CREATE_NEW_INTEGRATION
    },
    isUseExisting() {
      return this.initialRadioValue === constants.USE_EXISTING_SHEET
    },
    getConvrrtFormFields() {
      return this.formFieldGroups[0].fields || []
    },
  },
  created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors
  },
  mounted() {
    this.onScrollInToView()
  },
  methods: {
    ...mapActions('globalTheme', {}),
    ...mapActions({
      onChangeStep: actions.UPDATE_INTEGRATIONS_AUTH_STEP,
    }),

    onScrollInToView() {
      const container = document.getElementById('authWrap')
      container.scrollIntoView()
    },

    onChangeAuthStep(step: string) {
      this.onChangeStep(step)
      this.onScrollInToView()
    },
  },
  render: function (h) {
    const AuthenticationDescription = getAuthenticationDescription()
    const HorizontalLine = getHorizontalLine()
    const SheetSelectDropdown = getSheetSelectDropdown()
    const RadioGroup = getRadioGroup()
    const Input = getInput()
    const Radio = getRadio()
    const SheetSelectWrap = getSheetSelectWrap()
    const SheetSelectButtonWrap = getSheetSelectButtonWrap()
    const SheetNameContainer = getSheetNameContainer()
    const SheetName = getSheetName()
    const CheckboxInputLabel = getCheckboxInputLabel()
    const AuthSuccessBtnWrap = getAuthSuccessBtnWrap()
    const AuthDescriptionHeader = getAuthDescriptionHeader()
    const SelectFieldsContainer = getSelectFieldsContainer()

    const CustomCheckbox = getCustomCheckbox()

    const existingSpreadSheets = this.getExistingSpreadSheets.map(
      (option, index) => {
        return (
          <option id={index} value={option}>
            {option}
          </option>
        )
      },
    )

    return (
      <div style="width: 100%;">
        {this.currentStep === constants.AUTH_INIT && <IntegrationDescription />}

        {this.currentStep === constants.AUTH_SUCCESS && (
          <div>
            <AuthenticationDescription>
              <div style="padding: 45px;">
                <div>
                  <AuthDescriptionHeader>
                    Choose an option
                  </AuthDescriptionHeader>
                  <RadioGroup
                    theme={''}
                    orientation={'vertical'}
                    size={'md'}
                    initialValue={this.initialRadioValue}
                  >
                    <Radio
                      border={false}
                      otherValue={constants.USE_EXISTING_SHEET}
                      onRadioClick={(value) => {
                        this.initialRadioValue = value
                      }}
                    >
                      Create a new spreadsheet
                    </Radio>
                    <Radio
                      border={false}
                      otherValue={constants.USE_EXISTING_SHEET}
                      onRadioClick={(value) => {
                        this.initialRadioValue = value
                      }}
                    >
                      Use an existing spreadsheet
                    </Radio>
                  </RadioGroup>
                </div>

                {!this.isUnselected && (
                  <div>
                    <HorizontalLine></HorizontalLine>
                    <div>
                      {this.isCreateNew && (
                        <SheetNameContainer>
                          <SheetName>Spreadsheet Name</SheetName>
                          <Input
                            label=""
                            size="small"
                            mode={this.mode}
                            color="black"
                            placeholder="Give your Spreadsheet a name"
                            value={''}
                            onClear={() => {}}
                            onInput={(e) => {}}
                          ></Input>
                        </SheetNameContainer>
                      )}
                      {this.isUseExisting && (
                        <SheetNameContainer>
                          <SheetName>Spreadsheet Name</SheetName>
                          <SheetSelectWrap>
                            <SheetSelectDropdown placeholder="Select an existing spreadsheet">
                              {existingSpreadSheets}
                            </SheetSelectDropdown>
                            <SheetSelectButtonWrap>
                              <CvtButton
                                text="Select"
                                outlined={true}
                                specialPadding="12px"
                                color="success"
                                onClick={() => {}}
                              ></CvtButton>
                            </SheetSelectButtonWrap>
                          </SheetSelectWrap>
                        </SheetNameContainer>
                      )}
                    </div>

                    <SheetNameContainer>
                      <SheetName>Worksheet Name</SheetName>
                      <Input
                        label=""
                        size="small"
                        mode={this.mode}
                        color="black"
                        placeholder="Give your worksheet a name"
                        value={''}
                        onClear={() => {}}
                        onInput={(e) => {}}
                      ></Input>
                    </SheetNameContainer>

                    <HorizontalLine></HorizontalLine>

                    <SelectFieldsContainer>
                      <CheckboxInputLabel>
                        Select form fields to send to Google Sheets
                      </CheckboxInputLabel>

                      <div style="display:flex; flex-direction: column;gap: 15px;">
                        {this.getConvrrtFormFields.map((field) => (
                          <CustomCheckbox label={field.label} checked={false} />
                        ))}
                      </div>
                    </SelectFieldsContainer>

                    <HorizontalLine></HorizontalLine>

                    <CheckboxInputLabel>
                      Send additional data to Google Sheets
                    </CheckboxInputLabel>
                    <CustomCheckbox label="Submission Date" checked={false} />
                  </div>
                )}
              </div>
            </AuthenticationDescription>

            <AuthSuccessBtnWrap>
              <CvtButton
                text="Cancel"
                outlined={true}
                specialPadding="12px"
                color="light"
                onClick={() => {}}
              ></CvtButton>
              <CvtButton
                text="Save"
                outlined={true}
                specialPadding="12px"
                disabled={this.isUnselected}
                color="success"
                onClick={() => {
                  this.onChangeAuthStep(constants.INTEGRATION_COMPLETE)
                }}
              ></CvtButton>
            </AuthSuccessBtnWrap>
          </div>
        )}

        {this.currentStep === constants.INTEGRATION_COMPLETE && (
          <IntegrationReady />
        )}
      </div>
    )
  },
}
